"use client"

import { Button } from "@/components/ui/button"
import { Menu, Moon, Shield, Sun, X } from "lucide-react"
import { signOut, useSession } from "next-auth/react"
import { useTheme } from "next-themes"
import Link from "next/link"
import { useState } from "react"

export function Navbar() {
  const { theme, setTheme } = useTheme()
  const { status } = useSession()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <nav className="border-b fixed top-0 left-0 right-0 z-50 bg-background">
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center">
            <Link href="/" className="flex items-center space-x-2">
              <Shield className="h-6 w-6" />
              <span className="font-bold">Canal de Denúncias</span>
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-4">
            <Link href="/denuncias">
              <Button variant="ghost">Nova Denúncia</Button>
            </Link>
            <Link href="/consulta">
              <Button variant="ghost">Consultar Denúncia</Button>
            </Link>

            {status === "authenticated" && (
              <div className="flex items-center gap-4">
                <Link href="/admin">
                  <Button variant="ghost">Painel Admin</Button>
                </Link>
                <Button variant="ghost" onClick={() => signOut({ callbackUrl: "/" })}>
                  Sair
                </Button>
              </div>
            )}
            {/* {status === "authenticated" ? (
              <div className="flex items-center gap-4">
                <Link href="/admin">
                  <Button variant="ghost">Painel Admin</Button>
                </Link>
                <Button variant="ghost" onClick={() => signOut()}>
                  Sair
                </Button>
              </div>
            ) : (
              <Link href="/admin/login">
                <Button variant="ghost">Login</Button>
              </Link>
            )} */}

            <Button
              variant="ghost"
              size="icon"
              onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
            >
              <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
              <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
              <span className="sr-only">Toggle theme</span>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? (
                <X className="h-5 w-5" />
              ) : (
                <Menu className="h-5 w-5" />
              )}
              <span className="sr-only">Toggle menu</span>
            </Button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 space-y-2">
            <div className="flex flex-col space-y-2">
              <Link href="/denuncias">
                <Button variant="ghost" className="w-full justify-start">
                  Nova Denúncia
                </Button>
              </Link>
              <Link href="/consulta">
                <Button variant="ghost" className="w-full justify-start">
                  Consultar Denúncia
                </Button>
              </Link>

              {status === "authenticated" && (
                <>
                  <Link href="/admin">
                    <Button variant="ghost" className="w-full justify-start">
                      Painel Admin
                    </Button>
                  </Link>
                  <Button
                    variant="ghost"
                    className="w-full justify-start"
                    onClick={() => signOut({ callbackUrl: "/" })}
                  >
                    Sair
                  </Button>
                </>
              )}

              {/* {status === "authenticated" ? (
                <>
                  <Link href="/admin">
                    <Button variant="ghost" className="w-full justify-start">
                      Painel Admin
                    </Button>
                  </Link>
                  <Button
                    variant="ghost"
                    className="w-full justify-start"
                    onClick={() => signOut({ callbackUrl: "/" })}
                  >
                    Sair
                  </Button>
                </>
              ) : (
                <Link href="/admin/login">
                  <Button variant="ghost" className="w-full justify-start">
                    Login
                  </Button>
                </Link>
              )} */}

              <Button
                variant="ghost"
                className="w-full justify-start"
                onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
              >
                {theme === "dark" ? "Modo Claro" : "Modo Escuro"}
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  )
} 